/*
 * @Description: 自动化注册全局组件
 * @Author: ywl
 * @Date: 2021-03-05 17:30:36
 * @LastEditors: ywl
 * @LastEditTime: 2021-03-12 16:42:19
 */
import Vue from 'vue';

const commonIndexJS = require.context(
  '../components/common/',
  true,
  /index.ts$/,
);

commonIndexJS.keys().forEach((fileName) => {
  const list = commonIndexJS(fileName);
  for (const key of Object.keys(list)) {
    // console.log(key);

    Vue.component(key, list[key]);
  }
});
